import { mapActions } from 'vuex';
import { $EventBus } from '@/main';
import { deleteVersion } from '@/store/modules/contract/service/contract.service';

export default {
	name: 'DeleteVersionBtn',
	props: {
		value: {
			type: Boolean,
			required: false,
		},
		versionId: {
			type: [String, Number],
			required: false,
		},
	},
	data() {
		return {
			loading: false,
		};
	},
	created() {},
	mounted() {},
	computed: {},
	watch: {},
	methods: {
		...mapActions('contract', ['deleteVersion']),

		async removeVersion() {
			const { isConfirmed } = await this.$swal.fire({
				title: '¿Estás seguro de que quieres eliminar?',
				text: null,
				icon: 'question',
				showCancelButton: true,
				cancelButtonColor: '#0039a6',
				confirmButtonColor: '#e0e0e0',
				cancelButtonText: 'No',
				confirmButtonText: 'Sí',
				reverseButtons: true,
			});
			if (isConfirmed) {
				this.sendDeletion();
			}
		},

		async sendDeletion() {
			try {
				this.loading = true;
				await deleteVersion(this.versionId);
				$EventBus.$emit('showSnack', 'success', 'Registro eliminado');
				this.$emit('update');
			} catch (error) {
				this.showError(error?.response || error.toString());
			} finally {
				this.loading = false;
			}
		},

		showError(error) {
			let msmError = error?.data?.message;
			if (msmError) {
				msmError = Array.isArray(msmError) ? msmError.join(', ') : msmError;
			} else {
				msmError = error;
			}
			$EventBus.$emit('showSnack', 'error', msmError);
		},
	},
	components: {},
};
